// table列数据
export const tableProps = [
  {
    labelName: "标题",
    prop: "title",
    alink: true,
  },

  {
    labelName: "发布时间",
    prop: "publishTime",
  },
];

// 角色设置 信息修改 密码重置
// table 操作按钮
export const operateButtons = [];
